(function () {
  'use strict';

  // Phase 2.5: when a bike is selected and the user lands on a collection
  // page, fetch every product in the collection, intersect with that bike's
  // fitments, and replace the grid with ONLY matching products. Native
  // pagination is hidden because all matches now fit on one re-rendered
  // page.

  var FLIPSIDE_BASE = 'https://flipside-api.whitesplatform.com/v1';
  var STORAGE_KEY = 'gcdbp:selectedBike';
  var WMPF_STORAGE_KEY = 'seeker-dropdown-parts-finder-2025-state';
  var FITMENTS_CACHE_PREFIX = 'gcdbp:fitments:';
  var MATCHES_CACHE_PREFIX = 'gcdbp:matches:'; // matches per collection per bike

  var grid = document.getElementById('product-grid');
  if (!grid) return;

  // Collections flagged via the `custom.skip_bike_filter` metafield opt out
  // of fitment filtering entirely (e.g. gear, boots, helmets — categories
  // that aren't bike-specific).
  if (grid.getAttribute('data-skip-bike-filter') === 'true') return;

  var bike;
  try { bike = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); }
  catch (e) { return; }
  if (!bike || !bike.modelId || !bike.makeName) return;

  var pathMatch = window.location.pathname.match(/\/collections\/([^/]+)/);
  if (!pathMatch) return;
  var collectionHandle = pathMatch[1].toLowerCase();

  function extractToken() {
    var scripts = document.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var text = scripts[i].textContent || '';
      var m = text.match(/dist\.dropdown\.js\?data-token=([^&"'\\]+)/);
      if (m) return m[1];
    }
    return null;
  }
  var token = extractToken();
  if (!token) return;

  function handleFromUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([^?#/]+)/);
    return m ? m[1].toLowerCase() : null;
  }

  // Convert a Flipside fitment payload into the product shape renderMatches
  // expects. Used on /collections/all where we render straight from the
  // fitments list (no products.json intersection).
  function fitmentToProduct(f) {
    var handleMatch = f.product_url ? f.product_url.match(/\/products\/([^?#/]+)/) : null;
    var handle = handleMatch ? handleMatch[1].toLowerCase() : null;
    var price = (f.default_price || '').replace(/[^0-9.]/g, '');
    var qty = (typeof f.quantity_available === 'number') ? f.quantity_available : 0;

    return {
      id: f.id,
      handle: handle,
      title: f.name || '',
      images: f.image_url ? [{ src: f.image_url }] : [],
      variants: [{
        id: f.id,
        price: price,
        available: qty > 0
      }],
      _category: f.heading_parent || ''
    };
  }

  function isAllCollection() {
    return collectionHandle === 'all';
  }

  function escapeText(s) {
    return String(s).replace(/[&<>]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
    });
  }
  function escapeAttr(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function bikeName() {
    return bike.makeName + ' ' + bike.modelName + ' ' + bike.year;
  }

  function fetchFitments() {
    var cacheKey = FITMENTS_CACHE_PREFIX + bike.modelId;
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}

    return fetch(FLIPSIDE_BASE + '/fitments/model/' + encodeURIComponent(bike.modelId), {
      headers: { 'Authorization': 'Bearer ' + token }
    }).then(function (r) {
      if (!r.ok) throw new Error('Fitments fetch ' + r.status);
      return r.json();
    }).then(function (data) {
      try { sessionStorage.setItem(cacheKey, JSON.stringify(data)); } catch (e) {}
      return data;
    });
  }

  function getTotalProductCount() {
    var el = document.getElementById('ProductCount');
    if (!el) return null;
    var m = el.textContent.replace(/,/g, '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function fetchCollectionProducts() {
    var total = getTotalProductCount();
    var cacheKey = 'gcdbp:products:' + collectionHandle + ':' + (total || 'unknown');

    // Cache hit — instant return.
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}

    function pageUrl(p) {
      return '/collections/' + encodeURIComponent(collectionHandle) +
             '/products.json?limit=250&page=' + p;
    }

    function fetchOne(p) {
      return fetch(pageUrl(p))
        .then(function (r) { if (!r.ok) throw new Error('Page ' + p + ' ' + r.status); return r.json(); })
        .then(function (d) { return d.products || []; });
    }

    // Fast path: we know the total → calculate page count → fire all in parallel.
    if (total !== null && total >= 0) {
      var pageCount = Math.max(1, Math.ceil(total / 250));
      var promises = [];
      for (var p = 1; p <= pageCount; p++) promises.push(fetchOne(p));
      return Promise.all(promises).then(function (arrays) {
        var all = arrays.reduce(function (acc, a) { return acc.concat(a); }, []);
        try { sessionStorage.setItem(cacheKey, JSON.stringify(all)); } catch (e) {}
        return all;
      });
    }

    // Fallback: unknown count → sequential, stop when a short page arrives.
    var all = [];
    function seq(p) {
      return fetchOne(p).then(function (products) {
        if (products.length === 0) return all;
        all = all.concat(products);
        if (products.length < 250) return all;
        return seq(p + 1);
      });
    }
    return seq(1).then(function (result) {
      try { sessionStorage.setItem(cacheKey, JSON.stringify(result)); } catch (e) {}
      return result;
    });
  }

  function findPagination() {
    // Native pagination usually lives in a sibling/ancestor of the grid.
    // Try a few common selectors near the grid.
    var candidates = [
      document.querySelector('.pagination'),
      document.querySelector('nav.pagination'),
      document.querySelector('[role="navigation"].pagination'),
      grid.parentElement && grid.parentElement.querySelector('.pagination')
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i]) return candidates[i];
    }
    return null;
  }

  function clearFilter() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    try { localStorage.removeItem(WMPF_STORAGE_KEY); } catch (e) {}
    // On /collections/all the native filter UI is disabled (too many
    // products), so a plain reload strands the user in a 23k-product list.
    // Redirect them to the parts hub where each sub-collection is filterable.
    if (isAllCollection()) {
      window.location.href = '/collections/motorcycle-parts';
    } else {
      window.location.reload();
    }
  }

  function buildBannerEl() {
    var existing = document.querySelector('.scf-banner');
    if (existing) existing.remove();

    var banner = document.createElement('div');
    banner.className = 'scf-banner';
    banner.innerHTML =
      '<div class="scf-banner__inner">' +
        '<div class="scf-banner__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>' +
            '<path d="M8 12l3 3 5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</div>' +
        '<div class="scf-banner__text">' +
          '<strong class="scf-banner__title"></strong>' +
          '<span class="scf-banner__subtitle"></span>' +
        '</div>' +
        '<button type="button" class="scf-banner__clear" data-scf-clear>Clear</button>' +
      '</div>';

    banner.querySelector('[data-scf-clear]').addEventListener('click', clearFilter);
    grid.parentNode.insertBefore(banner, grid);
    return banner;
  }

  function setBanner(banner, opts) {
    if (opts.empty) banner.classList.add('scf-banner--empty');
    else banner.classList.remove('scf-banner--empty');

    banner.querySelector('.scf-banner__title').textContent = opts.title;
    banner.querySelector('.scf-banner__subtitle').textContent = opts.subtitle || '';
  }

  function setLoading(banner) {
    setBanner(banner, {
      title: 'Loading parts that fit your ' + bikeName() + '…',
      subtitle: 'Checking the full collection against your bike’s fitment list.'
    });
  }

  function setResults(banner, count) {
    if (count === 0) {
      setBanner(banner, {
        empty: true,
        title: 'No products in this collection fit your ' + bikeName(),
        subtitle: 'Try a different category, or clear the filter to see everything.'
      });
    } else {
      setBanner(banner, {
        title: 'Showing ' + count + ' product' + (count === 1 ? '' : 's') + ' that fit your ' + bikeName(),
        subtitle: 'Filtered against the full collection. Clear the filter to see everything.'
      });
    }
  }

  function renderMatches(matchingProducts) {
    // Clone the first existing grid-item as a styling template.
    var templateItem = grid.querySelector('li.grid-item');
    if (!templateItem) return false;

    // Grab section_id from any existing form on the page so cloned cards
    // can submit add-to-cart with the right context.
    var sectionIdInput = templateItem.querySelector('input[name="section-id"]');
    var sectionId = sectionIdInput ? sectionIdInput.value : null;

    var template = templateItem.cloneNode(true);

    // Hide all existing grid-items (we keep them in DOM so Clear can restore).
    grid.querySelectorAll('li.grid-item').forEach(function (el) {
      el.classList.add('scf-card-hidden');
    });

    matchingProducts.forEach(function (product) {
      var li = template.cloneNode(true);
      li.classList.add('scf-clone');

      // Category tag for the pill filter to target.
      if (product._category) {
        li.setAttribute('data-cat', product._category);
      }

      var variant = (product.variants && product.variants[0]) || null;
      var hasOneVariant = product.variants && product.variants.length === 1;
      var anyAvailable = product.variants && product.variants.some(function (v) { return v.available; });

      // Update product-card data-product-id
      var pc = li.querySelector('[data-product-id]');
      if (pc) pc.setAttribute('data-product-id', product.id);

      // Rewrite all /products/* hrefs
      li.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', '/products/' + product.handle);
      });

      // Image — use first image if present
      var imgEls = li.querySelectorAll('img.card-media-image');
      if (imgEls.length > 0) {
        var firstImg = (product.images && product.images[0]) || null;
        if (firstImg) {
          imgEls[0].setAttribute('src', firstImg.src);
          imgEls[0].setAttribute('alt', product.title || '');
          imgEls[0].removeAttribute('srcset');
          // Drop hover-swap secondary images so we don't show the template
          // product's second image alongside this product's first.
          for (var i = 1; i < imgEls.length; i++) imgEls[i].remove();
        }
      }

      // Title
      var titleLink = li.querySelector('.card-heading a');
      if (titleLink) titleLink.textContent = product.title || '';

      // Price (first variant's price)
      var priceEl = li.querySelector('.price-item-regular');
      if (priceEl && variant && variant.price != null) {
        priceEl.textContent = '$' + variant.price;
      }

      // Stock badge
      var stockBadge = li.querySelector('.badge-stock');
      if (stockBadge) {
        stockBadge.classList.remove('badge-stock-in', 'badge-stock-out');
        stockBadge.classList.add(anyAvailable ? 'badge-stock-in' : 'badge-stock-out');
        var stockText = stockBadge.querySelector('.js-stock-text');
        if (stockText) stockText.textContent = anyAvailable ? 'In stock' : 'Out of stock';
      }

      // Strip rating link (would point to wrong product reviews anchor)
      li.querySelectorAll('.star-rating-link').forEach(function (el) { el.remove(); });

      // Rewrite the floating footer. The cloned template's form was rendered
      // for a different product, so we replace the whole block based on this
      // product's stock state:
      //   - out of stock        → disabled "Out of stock" link
      //   - in stock, multi var → "Select options" link to PDP
      //   - in stock, single    → full <product-form> add-to-cart
      var footer = li.querySelector('.card-floating-footer');
      if (footer && variant) {
        var productUrl = '/products/' + product.handle;
        if (!anyAvailable) {
          footer.innerHTML =
            '<div class="card-product-actions"><div class="product-actions-add-to-cart">' +
            '<a role="link" aria-disabled="true" class="button button-secondary button-solid">Out of stock</a>' +
            '</div></div>';
        } else if (!hasOneVariant) {
          footer.innerHTML =
            '<div class="card-product-actions"><div class="product-actions-add-to-cart">' +
            '<a href="' + productUrl + '" class="button button-secondary button-solid js-product-link">Select options</a>' +
            '</div></div>';
        } else {
          var sectionAttr = sectionId ? ' data-section-id="' + escapeAttr(sectionId) + '"' : '';
          footer.innerHTML =
            '<product-form>' +
              '<form method="post" action="/cart/add" id="product-form-' + product.id + '"' +
                ' enctype="multipart/form-data" accept-charset="UTF-8" data-type="add-to-cart-form"' + sectionAttr + '>' +
                '<input type="hidden" name="form_type" value="product">' +
                '<input type="hidden" name="utf8" value="✓">' +
                '<input type="hidden" name="id" value="' + variant.id + '">' +
                '<div class="card-product-actions"><div class="product-actions-add-to-cart">' +
                  '<button type="submit" name="add" class="button button-secondary button-add-to-cart button-solid">' +
                    '<span>Add to cart</span>' +
                    '<div class="button-overlay-spinner hidden"><span class="spinner-xs"></span></div>' +
                  '</button>' +
                '</div></div>' +
                '<div class="product-form-error-message-wrapper form-status form-status-error" role="alert" hidden>' +
                  '<span class="product-form-error-message"></span>' +
                '</div>' +
              '</form>' +
            '</product-form>';
        }
      }

      grid.appendChild(li);
    });

    return true;
  }

  function updateProductCount(count) {
    var el = document.getElementById('ProductCount');
    if (!el) return;
    // Save original so Clear (which reloads) isn't strictly needed for
    // restore, but keep it for safety.
    if (!el.dataset.scfOriginal) el.dataset.scfOriginal = el.textContent.trim();
    el.textContent = count + ' Product' + (count === 1 ? '' : 's');
  }

  function buildCategoryFilter(products) {
    var existing = document.querySelector('.scf-cats');
    if (existing) existing.remove();

    var counts = {};
    products.forEach(function (p) {
      var c = p._category || '';
      if (!c) return;
      counts[c] = (counts[c] || 0) + 1;
    });

    var cats = Object.keys(counts).sort();
    if (cats.length <= 1) return; // Not useful — hide entirely.

    var nav = document.createElement('div');
    nav.className = 'scf-cats';
    nav.setAttribute('role', 'tablist');

    var html = '<button type="button" class="scf-cat-pill scf-cat-pill--active" data-scf-cat="">' +
      'All <span class="scf-cat-pill__count">' + products.length + '</span></button>';
    cats.forEach(function (c) {
      html += '<button type="button" class="scf-cat-pill" data-scf-cat="' + escapeAttr(c) + '">' +
        escapeText(c) + ' <span class="scf-cat-pill__count">' + counts[c] + '</span></button>';
    });
    nav.innerHTML = html;

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-scf-cat]');
      if (!btn) return;
      var cat = btn.getAttribute('data-scf-cat');

      nav.querySelectorAll('.scf-cat-pill').forEach(function (p) {
        p.classList.toggle('scf-cat-pill--active', p === btn);
      });

      grid.querySelectorAll('.scf-clone').forEach(function (card) {
        var cardCat = card.getAttribute('data-cat') || '';
        if (!cat || cardCat === cat) {
          card.classList.remove('scf-cat-hidden');
        } else {
          card.classList.add('scf-cat-hidden');
        }
      });
    });

    // Insert after the banner so it appears between banner and grid.
    var bannerEl = document.querySelector('.scf-banner');
    if (bannerEl) {
      bannerEl.parentNode.insertBefore(nav, bannerEl.nextSibling);
    } else {
      grid.parentNode.insertBefore(nav, grid);
    }
  }

  // ----- Run -----
  grid.classList.add('scf-filtered');
  // Body class lets CSS hide ancestor elements (e.g. the sort dropdown row,
  // which lives outside #product-grid).
  document.body.classList.add('scf-active');
  var banner = buildBannerEl();
  setLoading(banner);

  // Hide pagination immediately so the loading state isn't competing with it.
  var pagination = findPagination();
  if (pagination) pagination.classList.add('scf-pagination-hidden');

  function buildMatches(fitments, collectionProducts) {
    // First-wins handle → fitment map.
    var fitmentByHandle = {};
    fitments.forEach(function (f) {
      var h = handleFromUrl(f.product_url);
      if (h && !fitmentByHandle[h]) fitmentByHandle[h] = f;
    });

    if (isAllCollection()) {
      // No collection-side intersection — render straight from fitments.
      return Object.keys(fitmentByHandle).map(function (h) {
        return fitmentToProduct(fitmentByHandle[h]);
      });
    }

    if (!collectionProducts) return [];
    return collectionProducts.filter(function (p) {
      return fitmentByHandle[(p.handle || '').toLowerCase()];
    }).map(function (p) {
      var f = fitmentByHandle[(p.handle || '').toLowerCase()];
      p._category = f.heading_parent || '';
      return p;
    });
  }

  function fetchData() {
    if (isAllCollection()) {
      // Skip the 64-page products.json crawl on the all-products collection.
      return fetchFitments().then(function (f) { return [f, null]; });
    }
    return Promise.all([fetchFitments(), fetchCollectionProducts()]);
  }

  function rollback() {
    grid.classList.remove('scf-filtered');
    document.body.classList.remove('scf-active');
    grid.querySelectorAll('li.grid-item').forEach(function (el) {
      el.classList.remove('scf-card-hidden');
    });
    grid.querySelectorAll('li.scf-clone').forEach(function (el) { el.remove(); });
    var nav = document.querySelector('.scf-cats');
    if (nav) nav.remove();
    if (pagination) pagination.classList.remove('scf-pagination-hidden');
  }

  fetchData()
    .then(function (results) {
      var fitments = results[0];
      var collectionProducts = results[1];

      var matches = buildMatches(fitments, collectionProducts);

      var ok = renderMatches(matches);
      if (!ok) {
        setBanner(banner, {
          empty: true,
          title: 'Could not filter this collection',
          subtitle: 'No card template found on the page.'
        });
        return;
      }

      updateProductCount(matches.length);
      setResults(banner, matches.length);
      buildCategoryFilter(matches);
    })
    .catch(function (err) {
      console.warn('[scf] filter failed:', err);
      setBanner(banner, {
        empty: true,
        title: 'Could not filter — showing all products',
        subtitle: 'Tap clear and try again, or check your connection.'
      });
      rollback();
    });
})();
